"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsProvider_1 = require("../AnalyticsProvider");
/**
 * This provider uses Google Tag Manager
 *
 * ONSHOP-7116 this provider gets the dealer ID and provider ID from meta tags on the page
 *     (see the Redline implementation in the online-shopper repo)
 *     we don't need to pass them in the event bodies.
 */
var HyundaiProvider = /** @class */ (function (_super) {
    __extends(HyundaiProvider, _super);
    function HyundaiProvider(name, config) {
        var _this = _super.call(this, name) || this;
        _this.config = config;
        return _this;
    }
    /* Internal utility methods */
    /**
     * If we were passed an eventCallback, send the payload there.
     *     This is typical in Electric, where we want to push onto the parent window (dealer website) dataLayer.
     * If we were *not* passed an eventCallback, look for window.dataLayer.push in our context
     *     This is typical in Redline
     * Note that Google replaces the entire window.dataLayer object when it finishes loading, it is *not* safe to hold onto a reference to the push method directly.
     *
     * @protected
     * @param payload
     */
    HyundaiProvider.prototype.eventHandler = function (payload) {
        var eventHandler = this.config.eventCallback || window.dataLayer.push;
        eventHandler(payload);
    };
    /**
     * Returns the object shape needed for GTM virtual page views for Hyundai.
     * Documented: https://dealerinspire.atlassian.net/wiki/spaces/OS/pages/498568801/Electric+Virtual+Page+Views
     *
     * @protected
     * @param pagePath: kind of like a url / relative path
     * @param {string} dealId
     * @param {Vehicle} vehicle
     * @return {GTMPageViewEvent}
     */
    HyundaiProvider.prototype.getPageViewObject = function (pagePath) {
        return {
            page: pagePath,
        };
    };
    /**
     * Returns an object of vehicle details used in the generic Hyundai event calls.
     *
     * @protected
     * @param {Vehicle} vehicle
     * @return {HyundaiVehicleDetails}
     * @memberof HyundaiProvider
     */
    HyundaiProvider.prototype.getVehicleData = function (vehicle) {
        return {
            VCategory: vehicle.type || "",
            VTrim: vehicle.trim || "",
            VType: vehicle.bodytype || "",
            VYear: vehicle.year || "",
            Vmake: vehicle.make || "",
            Vmodel: vehicle.model || "",
            vin: vehicle.vin || "",
        };
    };
    /**
     * Returns the object shape needed for generic Hyundai analytics events
     * JF - 4.2 in the Hyundai documentation shows an extra dash (i.e. drs-) for the event value, but let's assume the one in 4.4 is correct without the dash
     *
     * @protected
     * @param eventType
     * @param {string} dealId
     * @param {Vehicle} vehicle
     * @return {HyundaiEvent}
     */
    HyundaiProvider.prototype.getEventObject = function (eventType, dealId, vehicle) {
        return __assign(__assign(__assign({}, this.getVehicleData(vehicle)), { event: "drs", DRSType: eventType }), (this.config.make === "GENESIS" && { "content-group": "drs" }));
    };
    /* Event Methods */
    HyundaiProvider.prototype.testDriveFormFinished = function (dealId, vehicle) {
        this.eventHandler(this.getEventObject("DRS-Test-Drive", dealId, vehicle));
    };
    HyundaiProvider.prototype.opened = function (dealId, vehicle) {
        this.eventHandler(this.getEventObject("DRS-Start", dealId, vehicle));
    };
    HyundaiProvider.prototype.hardCreditFormFinished = function (dealId, vehicle) {
        this.eventHandler(this.getEventObject("DRS-Credit-Application", dealId, vehicle));
    };
    HyundaiProvider.prototype.paymentCalcFinished = function (dealId, vehicle) {
        this.eventHandler(this.getEventObject("DRS-Payment-Calculator", dealId, vehicle));
    };
    HyundaiProvider.prototype.tradeInFormFinished = function (dealId, vehicle) {
        this.eventHandler(this.getEventObject("DRS-Trade-in", dealId, vehicle));
    };
    HyundaiProvider.prototype.virtualPageView = function (pagePath) {
        var VIRTUAL_PAGE_VIEWS = [
            "/online-shopper/payment-builder",
            "/online-shopper/lead-form",
            "/online-shopper/unlock-garage",
            "/online-shopper/access-my-garage",
            "/online-shopper/continue-deal",
            "/online-shopper/my-garage",
        ];
        if (!pagePath.includes("online-shopper") ||
            (pagePath.includes("online-shopper") && VIRTUAL_PAGE_VIEWS.includes(pagePath))) {
            this.eventHandler(this.getPageViewObject(pagePath));
        }
    };
    return HyundaiProvider;
}(AnalyticsProvider_1.AnalyticsProvider));
exports.default = HyundaiProvider;
